import React from 'react'

export default function pdfFolder(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 36">
        <g class="pdfFolder">
          <path
            
            d="M30.32 10.01v21.7c0 1.68-1.4 2.99-2.99 2.99H6.65c-1.68 0-2.99-1.4-2.99-2.99V5.52c0-1.68 1.31-3.09 2.99-3.09h16.09c.47 0 1.03.19 1.31.56l5.71 5.61c.28.37.56.84.56 1.4v.01Z"
            class="st1"
            opacity=".1"
          />
          <path
            
            d="m30.7 8.09-5.99-5.8c-.28-.37-.84-.56-1.31-.56H6.56a3.15 3.15 0 0 0-3.18 3.18v27.32c0 1.78 1.4 3.18 3.18 3.18h21.61c1.78 0 3.18-1.4 3.18-3.09V9.68c.09-.65-.19-1.22-.65-1.59Zm-.47 23.29c0 1.59-1.31 2.99-2.9 2.99H7.4c-1.59 0-2.9-1.31-2.9-2.99V5.75c0-1.59 1.31-2.99 2.9-2.99h15.44c.47 0 .94.19 1.31.56l5.52 5.43c.37.37.65.94.56 1.5v21.14-.01Z"
            class="st1"
          />
          <g class="Group 83">
            <g class="Group 82">
              <path
                
                d="M1.61 5.47h15.66c.51 0 .92.42.92.96v6.01c0 .53-.41.96-.92.96H.69V6.44c0-.53.41-.94.92-.94v-.03Z"
                class="st1"
              />
              <path
                
                d="M18.12 12.29v.12c0 .53-.41.96-.92.96H.63V6.41c0-.53.41-.96.92-.96h.48v2.47c0 2.41 1.87 4.37 4.2 4.37h11.9-.01Z"
                class="st2"
              />
              <path
                
                fill-opacity=".6"
                d="m.63 13.37 2.78 3.27v-3.27H.63Z"
                class="st2"
                opacity=".3"
              />
            </g>
            <g class="Group">
              <path
                fill="#F1F2F2"
                d="M3.616 11.5V6.284h1.792c.384 0 .73.053 1.04.16.315.101.565.275.752.52.187.245.28.579.28 1 0 .405-.093.739-.28 1a1.685 1.685 0 0 1-.744.584c-.31.123-.648.184-1.016.184h-.648V11.5H3.616Zm1.176-2.704h.576c.325 0 .565-.072.72-.216.16-.144.24-.35.24-.616 0-.277-.085-.47-.256-.576-.17-.112-.416-.168-.736-.168h-.544v1.576Zm3.59 2.704V6.284h1.472c.533 0 .994.09 1.384.272.394.181.698.464.912.848.213.379.32.867.32 1.464s-.107 1.09-.32 1.48a2.05 2.05 0 0 1-.896.872c-.379.187-.822.28-1.328.28H8.382Zm1.176-.952h.224c.298 0 .557-.053.776-.16.224-.107.397-.283.52-.528.122-.245.184-.576.184-.992 0-.416-.062-.741-.184-.976a1.037 1.037 0 0 0-.52-.504 1.83 1.83 0 0 0-.776-.152h-.224v3.312Zm3.902.952V6.284h3.288v.992h-2.112v1.208h1.808v.992h-1.808V11.5H13.46Z"
                class="pdf"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  )
}
